import { startOfWeek } from 'date-fns';

// Public availability uses the same Monday–Sunday range as the server.
export const getBookingWeekStart = (date) => startOfWeek(date, { weekStartsOn: 1 });
